import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import NavUserProfileDropDown from "./NavUserProfileDropDown";
import Form from "olive-react-myoneui/lib/Form";
import axios from "axios";

import { useTranslation } from "react-i18next";
import {
  bellIcon,
  chatIcon,
  helpIcon,
  viewLiveSiteIcon,
  menuHamburgerIcon,
  menuCloseIcon
} from "../constants/icons";
import OffcanvasNavMenu from "./OffcanvasNavMenu";
import { getProductsData } from "../../api/initialApis";
import { availableLanguages } from "../../constants/config";
import { setLangInCache } from "../../utils/helpers";
import MykademyLogo from "../../assets/img/mykademy-logo.svg";
import OffcanvasMessages from "./student-dashboard/OffcanvasMessages";
import OffcanvasNotification from "./student-dashboard/OffcanvasNotificaton";
import MobileBaseNavigation from "./MobileBaseNavigation";
import { getNotificationCount } from "../../api/afterLogin/notification";
import { getMessageCount } from "../../api/afterLogin/setting";
import { readCookie } from "../../utils/cookie";
import Skeleton from 'react-loading-skeleton'

function NavigationBarDashboard() {
  const { t, i18n } = useTranslation();
  const [menuActive, setMenuActive] = useState(false);
  const [productsDummy, setProducts] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const adminData    = useSelector((state) => state.admin);
  const loggedInUser = useSelector((state) => state.user.user);
	const paths = useSelector((state) => state.user.paths);
  
	const [notificationcount, setNotificationCount] = useState();
	const [messageCount, setMessageCount] = useState(null);
  const preview_as_user = readCookie("preview_as_user");

  const [renderLogo, setRenderLogo] = useState();
  const header = adminData.header;
  
  const getProducts = async () => {
    try {
      const response = await getProductsData();
      setProducts(response.data.data.productsDummy);
    } catch (error) {
      console.log(error);
    }
  };

  const productsList = [
    {
      "id": "1",
      "url": "",
      "name": "Mykademy",
      "logo": null,
      "offer": ""
    },
    {
      "id": "2",
      "url": "",
      "name": "Booking management",
      "logo": null,
      "offer": ""
    },
    {
      "id": "3",
      "url": "",
      "name": "Document Management",
      "logo": null,
      "offer": ""
    }
  ]

  const products = [
    {
      "id": 1,
      "url": "https://vle.com",
      "name": "VLE",
      "logo": "https://olivegroup.io/wp-content/uploads/2021/10/olive-group-favicon-32x32-1.png",
      "offer": ""
    },
    {
      "id": 2,
      "url": "https://myconnect.com",
      "name": "Myconnect",
      "logo": "https://olivegroup.io/wp-content/uploads/2021/10/olive-group-favicon-32x32-1.png",
      "offer": ""
    },
    {
      "id": 3,
      "url": "https://mykademy.com",
      "name": "Mykademy Classes",
      "logo": "https:\/\/d2cl07xv2ii8xi.cloudfront.net\/uploads\/enterprisedev.uk.mykademy.com\/items_org\/favicon.png?v=1.924v1",
      "offer": ""
    },
    {
      "id": 4,
      "url": "https://mykademyenterprise.com",
      "name": "Mykademy Enterprise",
      "logo": "https:\/\/d2cl07xv2ii8xi.cloudfront.net\/uploads\/enterprisedev.uk.mykademy.com\/items_org\/favicon.png?v=1.924v1",
      "offer": ""
    },
    {
      "id": 5,
      "url": "https://olivevle.com",
      "name": "Olive VLE",
      "logo": "https://olivegroup.io/wp-content/uploads/2021/10/olive-group-favicon-32x32-1.png",
      "offer": "13 days left"
    },
    {
      "id": 6,
      "url": "https://oliveedx.com",
      "name": "Olive EDX",
      "logo": "https://olivegroup.io/wp-content/uploads/2021/10/olive-group-favicon-32x32-1.png",
      "offer": ""
    }
  ]

  useEffect(() => {
    setProducts(productsList);
  }, []);

  const onLangChange = (e) => {
    i18n.changeLanguage(e.target.value);
    setLangInCache(e.target.value);
  };

  const onHamburgerClick = (e) => {
    const body = document.body;
    if (body.classList.contains("menu-active")) {
      body.classList.remove("menu-active");
      setMenuActive(false);
    } else {
      body.classList.add("menu-active");
      setMenuActive(true);
    }
  };

  const onViewSiteClick = (e) => {
    e.preventDefault();
    const origin = window.location.origin;
		setTimeout(function () {
			window.open(`${origin}/course/listing`, '_blank');
		}, 500);
  };

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const fetchMessageCount = async () => {
    const params = {
      host: paths.message_api_url,
      userId: loggedInUser.logged_in_user.id,
      accessToken: loggedInUser.logged_in_user.token
    }
    const response = await getMessageCount(params);
    if (response) {
      setMessageCount(response?.data?.count)
    }
  }

  const fetchNotificationCount = async () => {
    if (loggedInUser.is_logged_in) {
      const host = window.location.hostname
      const params = {
        host: host,
        user: loggedInUser.is_logged_in
      }
      const response = await getNotificationCount(params);
      if (response) {
        setNotificationCount(response.data.count)
      }
    }
  }

  useEffect(() => {
    fetchMessageCount();
    fetchNotificationCount();
    setRenderLogo(header.logo)
	}, [paths.message_api_url, header.logo]);

  return (
    <>
      <nav className="navbar navbar-expand-md navbar-student-dashboard sticky-top backdrop-filter">
        <div className="container-fluid">
          <div className="logo-toggle-wrapper d-flex align-items-center gap-4">
            <div
              className="mobile-menu d-flex gap-2 d-md-none"
              onClick={onHamburgerClick}
            >
              <span className="sidebar-toggle">
                {menuActive ? menuHamburgerIcon : menuHamburgerIcon}
              </span>
            </div>
            {renderLogo ? (
            <a className="navbar-brand" href={window.location.origin}>
              <img src={renderLogo} width="150" alt="Logo" onError={(e) => e.target.src = renderLogo} />
            </a>
            ) : (
            <span className="no-navbar-brand">
              <Skeleton width={"150px"} height={"50px"}/>
            </span>
            )}
          </div>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
          >
            <div className="navbar-wrapper d-flex align-items-center gap-3">
              <Form.Select
                className="p-2 w-auto"
                data-testid="langselect"
                value={i18n.language}
                onChange={onLangChange}
              >
                {availableLanguages.map((lang, i) => (
                  <option key={i} value={lang.value}>
                    {lang.label}
                  </option>
                ))}
              </Form.Select>
              <button
                className="btn text-icon btn-round btn-sm"
                type="button"
                onClick={onViewSiteClick}
              >
                <span className="d-none gap-2 d-lg-flex">
                  {t("Explore courses")}
                </span>
                {viewLiveSiteIcon}
              </button>
              <div className="ui-nav-divider"></div>
              <ul className="navbar-nav mb-lg-0 d-flex gap-3">
                <li className="nav-item">
                  <a
                    className="nav-link d-flex align-items-center gap-2"
                    aria-current="page"
                    href="#"
                  >
                    {helpIcon}
                    <span className="d-none gap-2 d-lg-flex">{t("Help")}</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" aria-current="page" href="#top">
                    <OffcanvasNotification triggerTitle={bellIcon} notificationcount={notificationcount} setNotificationCount={setNotificationCount} />
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a className="nav-link" href="#">
                    {chatIcon}
                  </a>
                </li> */}
                <li className="nav-item">
                  <OffcanvasMessages triggerTitle={chatIcon} messageCount={messageCount} setMessageCount={setMessageCount} />
                </li>
              </ul>
               <NavUserProfileDropDown preview_as_user={preview_as_user} />
            </div>
          </div>
          <div className="mobile-menu d-flex align-items-center gap-3 d-md-none">
            <ul className="navbar-nav mb-0 mb-lg-0 d-flex gap-3">
              <li className="nav-item">
                <a className="nav-link" aria-current="page" href="#top">
                  <OffcanvasNotification triggerTitle={bellIcon} notificationcount={notificationcount} setNotificationCount={setNotificationCount} />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <OffcanvasNavMenu />
      </nav>
      {screenWidth < 768 && (
        <MobileBaseNavigation />
      )}
    </>
  );
}

export default NavigationBarDashboard;
